module.exports = __webpack_public_path__ + "static/media/Videos@3x.e33ed9cd.webp";